export enum FileTypeEnum {
    INSTALLER = 'INSTALADOR',
    EXECUTABLE = 'EXECUTAVEL',
    UPDATE = 'ATUALIZACAO',
    DB =   'BANCO DE DADOS',
}

export enum FileTypeIdEnum {
    INSTALADOR = 1,
    EXECUTAVEL = 2,
    ATUALIZACAO = 3, 
    BANCO_DE_DADOS 
}


export function getFileTypeDescriptionByValue(value: number): string | undefined {
    const key = Object.keys(FileTypeIdEnum).find((key) => FileTypeIdEnum[key as keyof typeof FileTypeIdEnum] === value);

    return key;
}
